import React, { forwardRef, useEffect } from 'react';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { t } from 'i18next';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { FormatInvoiceDecimalNumber, getValueFromResource, formatDateWithDateAndMonthName } from '../../../common/timeLiveFunction';

const InvoicePrintWidget = forwardRef((props: any, ref: any) => {
    const dispatch = useAppDispatch();
    const { masterRecordArray, timesheetArray, expenseArray, masterArray, taxArray, logoPath } = props;
    const { masterAccountTimeExpenseBilling } = useAppSelector((state) => state.invoiceBilling);
    const { cultureInfoName, decimalPlaces, showProjectNameInInvoiceReport, showBillingRateInInvoiceReport, showEntryDateInInvoiceReport, showEmployeeNameInInvoiceReport, isCompanyOwnLogo, manageTerminologyList } = useAppSelector((state) => state.globalState);
    const getMasterRecord: any = masterAccountTimeExpenseBilling[0];

    useEffect(() => {
    }, []);

    console.log('timesheetArray',timesheetArray)

    const getLabelNameFromTerminology = (Value: string) => {
        if (manageTerminologyList && manageTerminologyList.length > 0) {
            for (let manageTerminologyItem of manageTerminologyList) {
                let isManageTerminologyExist: boolean = Value.includes(manageTerminologyItem.TerminologyName);
                if (isManageTerminologyExist) {
                    return Value.replace(Value, manageTerminologyItem.UserDefinedName).toString();
                }
            }
        }
        return Value.toString();
    }

    return (
        <>
            <div ref={ref}>
                <div className='modal-body pt-0 pb-15 px-5 px-xl-5'>
                    <div className='row text-left mb-3' style={{ marginTop: 25 }}>
                        {isCompanyOwnLogo && <img
                            src={logoPath}
                            alt={logoPath} style={{ width: '180px', height: '50px' }} />}
                        {/* <img src={toAbsoluteUrl('/media/logos/livetecs-Icon.svg')} className='tsReportIcon'></img>
                        <img src={toAbsoluteUrl('/media/logos/livetecs.svg')} className='tsReportLogo'></img> */}
                        <div style={{ textAlign: 'right' }}>
                            <span className='textDarkBlue' style={{ fontWeight: 600, fontSize: 15 }}>{masterArray.AccountName}</span><br />
                            <span className='reportLabel'>{masterArray.AccountAddress1}</span><br />
                            <span className='reportLabel'>{masterArray.AccountAddress2}</span><br />
                            <span className='reportLabel'>{masterArray.City}</span><br />
                            <span className='reportLabel'>{`${masterArray.ZipCode}`}</span><br />
                            <span className='reportLabel'>{masterArray.AccountCountry}</span><br />
                            <span className='reportLabel'>{masterArray.Telephone}</span><br /><br />
                            <span className='invoiceReportLabel'>
                                {/* {t('Invoice No:')} */}
                                {getValueFromResource('Invoice No:',dispatch, t)}
                                 </span>
                            {/* <span className='invoiceReportText'>{masterArray.InvoiceNumber}</span><br /> */}
                            <span className='invoiceReportText'>{masterArray.InvoiceNoPrefix === '' ? masterArray.InvoiceNumber : masterArray.InvoiceNoPrefix + '-' + masterArray.InvoiceNumber}</span><br />
                            <span className='invoiceReportLabel'>
                                {/* {t('PO Number:')} */}
                                {getValueFromResource('PO Number:',dispatch, t)}
                                 </span>
                            <span className='invoiceReportText'>{masterArray.PONumber}</span><br />
                            <span className='invoiceReportLabel'>
                                {/* {t('Invoice Date:')}  */}
                                {getValueFromResource('Invoice Date:',dispatch, t)}
                                </span>
                                       <span className='invoiceReportText'>{masterArray.InvoiceDate}</span><br />
                            <span className='invoiceReportLabel'>
                                {/* {t('Due Date:')} */}
                                {getValueFromResource('Due Date:',dispatch, t)}
                                 </span>
                                    <span className='invoiceReportText'>{masterArray.DueDate}</span><br />
                        </div>
                        <div style={{ marginLeft: -5, marginTop: 20 }}>
                            <span className='reportText'>
                                {/* {t('Billed To')} */}
                                {getValueFromResource('Billed To',dispatch, t)}
                                </span> <br />
                            <span className='invoiceReportLabelLeft'>{masterArray.ClientName}</span><br />
                            <span className='invoiceReportLabelLeft'>{masterArray.Address1}</span><br />
                            {masterArray.Address2 != "" && <><span className='invoiceReportLabelLeft'>{masterArray.Address2}</span><br /></>}
                            <span className='invoiceReportLabelLeft'>{`${masterArray.ClientCity} ${masterArray.ClientState}`}</span><br />
                            <span className='invoiceReportLabelLeft'>{masterArray.ClientZipcode}</span><br />
                            <span className='invoiceReportLabelLeft'>{masterArray.ClientCountry}</span><br />
                            <span className='invoiceReportLabelLeft'>{masterArray.ClientTelephone}</span><br /><br />
                            <span className='reportText'>
                                {/* {t('Billing Period')} */}
                                {getValueFromResource('Billing Period',dispatch, t)}
                                </span> <br />
                            <span className='invoiceReportLabelLeft' style={{ paddingRight: 4 }}>
                                {/* {t('Start Date:')} */}
                                {getValueFromResource('Start Date:',dispatch, t)}
                                </span>
                             <span className='invoiceReportText'>{masterArray.StartDate}</span><br />
                            <span className='invoiceReportLabelLeft' style={{ paddingRight: 8 }}>
                                {/* {t('End Date:')} */}
                                {getValueFromResource('End Date:',dispatch, t)}
                                </span>
                            <span className='invoiceReportText'>{masterArray.EndDate}</span><br />
                        </div>
                    </div>
                    {timesheetArray.length > 0 &&
                        <table className='tsReportCommentTable mb-6'>
                            <thead>
                                <tr className='invoiceReportThead'>
                                    {/* {showEntryDateInInvoiceReport && <th className='min-w-100px invoiceTH'>{t('Entry Date')}</th>} */}
                                    {showEntryDateInInvoiceReport && <th className='min-w-100px invoiceTH'
                                    >
                                        {/* {t(getLabelNameFromTerminology('Entry Date'))} */}
                                        {getValueFromResource('Entry Date',dispatch, t)}
                                    </th>}
                                    {/* {showEmployeeNameInInvoiceReport && <th className='min-w-100px invoiceTH'>{t('Employee Name')}</th>} */}
                                    {showEmployeeNameInInvoiceReport && <th className='min-w-100px invoiceTH'>
                                        {/* {t(getLabelNameFromTerminology('Employee Name')) */}
                                        {getValueFromResource('Employee Name',dispatch, t)}
                                        </th>}
                                    {/* {showProjectNameInInvoiceReport && <th className='min-w-100px invoiceTH'>{t('Project Name')} </th>} */}
                                    {showProjectNameInInvoiceReport && <th className='min-w-100px invoiceTH'>
                                        {/* {t(getLabelNameFromTerminology('Project Name'))} */}
                                        {getValueFromResource('Project Name',dispatch, t)}
                                         </th>}
                                    {/* <th className='min-w-100px invoiceTH'>{t('Description')}</th> */}
                                    <th className='min-w-100px invoiceTH'>
                                        {/* {t(getLabelNameFromTerminology('Description'))} */}
                                        {getValueFromResource('Description',dispatch, t)}
                                        </th>
                                    {/* {showBillingRateInInvoiceReport && <th className='min-w-100px invoiceTH text-right'>{t('Billing Rate')}</th>} */}
                                    {showBillingRateInInvoiceReport && <th className='min-w-100px invoiceTH text-right'>
                                        {/* {t(getLabelNameFromTerminology('Billing Rate'))} */}
                                        {getValueFromResource('Billing Rate',dispatch, t)}
                                        </th>}
                                    {/* <th className='min-w-100px invoiceTH text-right'>{t('Billing Hours')}</th> */}
                                    <th className='min-w-100px invoiceTH text-right'>
                                        {/* {t(getLabelNameFromTerminology('Billing Hours'))} */}
                                        {getValueFromResource('Billing Hours',dispatch, t)}
                                        </th>
                                    {/* <th className='min-w-100px invoiceTH text-right'>{t('Billing Amount')}</th> */}
                                    <th className='min-w-100px invoiceTH text-right'>
                                        {/* {t(getLabelNameFromTerminology('Billing Amount'))} */}
                                        {getValueFromResource('Billing Amount',dispatch, t)}
                                        </th>
                                </tr>
                            </thead>
                            <tbody>
                                {timesheetArray.length > 0 && timesheetArray.map((item: any, index: number) => {
                                    return (
                                        <tr key={index} className='tsReportCommentTbody'>
                                            {/* {showEntryDateInInvoiceReport && <td className='paddingLeft'>{getMasterRecord.GroupTimesheetBillingListBy === "TimeEntry" ? moment(item.TimeEntryDate).format('YYYY-MM-DD') : ""}</td>} */}
                                            {showEntryDateInInvoiceReport && <td className='paddingLeft'>{item.TimeEntryDate ? moment(item.TimeEntryDate).format('DD/MM/YYYY') : ""}</td>}
                                            {/* {showEmployeeNameInInvoiceReport && <td className='paddingLeft'>{getMasterRecord.GroupTimesheetBillingListBy === "TimeEntry" ? item.EmployeeName : ""}</td>} */}
                                            {/* {showEmployeeNameInInvoiceReport && <td className='paddingLeft'>{getMasterRecord.GroupTimesheetBillingListBy === "TimeEntry" || getMasterRecord.GroupTimesheetBillingListBy === "Employee" ? item.EmployeeName : ""}</td>} */}
                                            {showEmployeeNameInInvoiceReport && <td className='paddingLeft'>{item.EmployeeName ? item.EmployeeName : ""}</td>}
                                            {showProjectNameInInvoiceReport && <td className='paddingLeft'>{item.ProjectName}</td>}
                                            <td className='paddingLeft'>{item['Detail Description']}</td>
                                            {showBillingRateInInvoiceReport && <td className='paddingLeft text-right'>{item.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.ActualBillingRate, decimalPlaces)}</td>}
                                            <td className='paddingLeft text-right'>{FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.BillHours , 2) }</td>
                                            <td className='paddingLeft text-right'>{item.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.TotalAmount, decimalPlaces)}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    {showEntryDateInInvoiceReport && <td></td>}
                                    {showEmployeeNameInInvoiceReport && <td></td>}
                                    {showProjectNameInInvoiceReport && <td></td>}
                                    <td></td>
                                    {showBillingRateInInvoiceReport && <td></td>}
                                    <td></td>
                                    <td className='paddingLeft text-right' style={{ height: 50 }}>
                                        {/* <span>{'Total:'}</span> */}
                                        <span className='invoiceReportText'>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.TotalTimesheetAmount, decimalPlaces)}</span>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>}
                    {expenseArray.length > 0 &&
                        <table className='tsReportCommentTable'>
                            <thead>
                                <tr className='invoiceReportThead'>
                                    {/* {showProjectNameInInvoiceReport && <th className='invoiceTH' style={{ width: '50%' }}>{t('Project Name')}</th>} */}
                                    {showProjectNameInInvoiceReport && <th className='invoiceTH' style={{ width: '50%' }}>
                                        {/* {t(getLabelNameFromTerminology('Project Name'))} */}
                                        {getValueFromResource('Project Name',dispatch, t)}
                                        </th>}
                                    {/* <th className='invoiceTH' style={{ width: '30%' }}>{t('Expense Description')}</th> */}
                                    <th className='invoiceTH' style={{ width: '30%' }}>
                                        {/* {t(getLabelNameFromTerminology('Expense Description'))} */}
                                        {getValueFromResource('Expense Description',dispatch, t)}
                                        </th>
                                    {/* <th className='invoiceTH text-right' style={{ width: '20%' }}>{t('Billed Amount')}</th> */}
                                    <th className='invoiceTH text-right' style={{ width: '20%' }}>
                                        {/* {t(getLabelNameFromTerminology('Billed Amount'))} */}
                                        {getValueFromResource('Billed Amount',dispatch, t)}
                                        </th>
                                </tr>
                            </thead>
                            <tbody>
                                {expenseArray.length > 0 && expenseArray.map((item: any, index: number) => {
                                    return (
                                        <tr key={index} className='tsReportCommentTbody'>
                                            {showProjectNameInInvoiceReport && <td className='paddingLeft' style={{ paddingLeft: 10 }}>{item.ProjectName}</td>}
                                            <td className='paddingLeft'>{item.Description}</td>
                                            <td className='paddingLeft text-right'>{item.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.BilledExpenseAmount, decimalPlaces)}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    {showProjectNameInInvoiceReport && <td></td>}
                                    <td></td>
                                    <td className='paddingLeft text-right' style={{ height: 50 }}>
                                        {/* <span>{'Total:'}</span> */}
                                        <span className='invoiceReportText'>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.TotalExpenseAmount, decimalPlaces)}</span>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>}
                    <br />
                    <div style={{ textAlign: 'right' }}>
                        <span className='invoiceReportLabel'>
                            {/* {t('Sub Total:')}  */}
                            {getValueFromResource('Sub Total:',dispatch, t)}
                            </span>
                        <span className='invoiceReportTextFooter mb-3'>{FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.SubTotal, decimalPlaces)}</span><br />
                        <span className='invoiceReportLabel'>
                            {getValueFromResource('Discount',dispatch, t)}
                        </span>
                        <span className='invoiceReportTextFooter mb-3'>{"- " + masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.Discount, decimalPlaces)}</span><br />
                        {taxArray.length > 0 && taxArray[0].TaxCodeName != "null" && taxArray.map((item: any, index: number) => {
                            return (<><span className='invoiceReportLabel' style={{ paddingLeft: 6 }}>{t(item.TaxCodeName)} </span>
                                <span className='invoiceReportTextFooter mb-3'>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.TotalTaxCode, decimalPlaces)}</span><br /></>
                            )
                        })}
                        <span style={{ borderTop: '1px solid #172b4d', borderBottom: '1px solid #172b4d', padding: '6px 0' }}>
                            <span className='invoiceReportLabel' >
                                {/* {t('Grand Total: ')} */}
                                {getValueFromResource('Grand Total:', dispatch, t)}
                                 </span>
                            <span className='invoiceReportTextFooter'>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.GrandTotal, decimalPlaces)}</span>
                        </span>
                    </div>
                    <div>
                        {masterArray.MasterDescription != undefined && masterArray.MasterDescription.map((item: any, index: any) => (
                            <p key={index} style={{ whiteSpace: 'pre-wrap' }}>
                                {item.replace(/\t+/g, ' ').trim()}
                            </p>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
});
export default InvoicePrintWidget